import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';
import { FaPen, FaTrash } from 'react-icons/fa';
import {Rest} from "../../Helpers/Rest" 
import {check_roles} from "../../Helpers/Roles" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
var moment = require('moment'); // require
export default class List extends Component {
  state = {}

  componentDidMount = () => {
    this.load()
  };

  load = () => {
    var rest = new Rest(this)
    rest.request("abouts", "GET", {}, (res)=>{ 
      this.setState({
        data: res
      })
    })
  }
 
  
  render() {
    console.log(this.state)
    return (
      <Container>
          <Row className="mt-3 mb-3">
            <Col>
                <h4>Pages about of your company</h4>
            </Col>
          </Row>

          {
            this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
          }
          <Row>
              <Col> 
                  <Table>
                      <thead>
                          <tr>
                              <th>ID</th>
                              <th>category</th> 
                          </tr>
                      </thead>
                      <tbody>
                          {
                            this.state.data && this.state.data.length && this.state.data.map(el=>{
                              return (
                                <tr key={el.id}>
                                  <td><a href={"/abouts/edit/"+el.id}>{el.id} <FaPen size={13} title="edit" /></a> </td> 
                                  <td>{el.category}</td> 
                                </tr>
                              )
                            })
                          }
                      </tbody>
                  </Table>
              </Col>
          </Row>
          
      </Container>
    );
  }
}
